import { schema, normalize } from 'normalizr';

const availableProvider = new schema.Entity('availableProviders');

const availableProviderListSchema = new schema.Array(availableProvider);

export default data => ({
  ...normalize(data, availableProviderListSchema),
});



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/normalizers/schedulings-normalizer.js